<div class="control-container" *ngIf="!order">
    <div class="div-container">
        <div class="page-title">Warenkorb wird<br>überprüft</div>
        <i class="fa-solid fa-basket-shopping"></i>
        <p>Dies dauert nur einen Moment. Es geht gleich weiter</p>

    </div>
    <div class="background"></div>
</div>
@if (order) {
<div class="control-container" *ngIf="!restriction">
    <div class="div-container">
        <div class="page-title">Haben Sie alle<br>Produkte erfasst?</div>
        <i class="fa-solid fa-user-shield"></i>
        <p>Es können Stichproben durchgeführt werden</p>
        <div class="buttons">
            <button [routerLink]="['/basket']">Zurück zum Warenkorb</button>
            <button [routerLink]="['/checkout']">
                <i class="fa-solid fa-circle-check"></i>
                Ja, alles in Ordnung
            </button>
        </div>
    </div>
    <div class="background"></div>
</div>
@if (restriction) {
@switch (restrictionState) {
@case (restrictionStateEnum.open) {
<div class="control-container restricted">
    <div class="div-container">
        <div class="page-title">Altersverifizierung<br>erforderlich</div>
        <div class="age-restriction">
            <i class="fa-regular fa-circle"></i>
            <span>{{restriction + "+"}}</span>
        </div>
        <p>Sie haben Produkte im Warenkorb die nur<br>für Volljährige bestimmt sind.</p>
        <div class="buttons">
            <button [routerLink]="['/basket']">Zurück zum Warenkorb</button>
            <button disabled style="opacity:0.5">
                <i class="fa-solid fa-circle-check"></i>
                Fortfahren
            </button>
        </div>
    </div>
    <div class="background"></div>
</div>
}

@case (restrictionStateEnum.passed) {
<div class="control-container restricted success">
    <div class="div-container">
        <div class="page-title">Altersverifizierung<br>erfolgreich</div>
        <div class="age-restriction">
            <i class="fa-regular fa-circle"></i>
            <span>{{restriction + "+"}}</span>
        </div>
        <p>Ihr Alter wurde erfolgreich verifiziert.</p>
        <div class="buttons">
            <button [routerLink]="['/basket']">Zurück zum Warenkorb</button>
            <button (click)="restriction = null">
                <i class="fa-solid fa-circle-check"></i>
                Fortfahren
            </button>
        </div>
    </div>
    <div class="background"></div>
</div>
}

@case (restrictionStateEnum.failed) {
<div class="control-container restricted">
    <div class="div-container">
        <div class="page-title">Altersverifizierung<br>fehlgeschlagen</div>
        <div class="age-restriction">
            <span>{{restriction + "+"}}</span>
            <i class="fa-solid fa-ban"></i>
        </div>
        <p>Leider konnte Ihr Alter nicht erfolgreich verifiziert werden.</p>

        <div class="removal-list">
            <h4>Folgende Produkte werden aus Ihrem Warenkorb entfernt</h4>
            <ul>
                <li *ngFor="let item of removedItems">{{item.quantity + 'x ' + item.article.description}}<div>CHF <span>{{'-' + (item.article.discountedPrice | number:'1.2-2')}}</span></div></li>
            </ul>
        </div>
        <div class="buttons">
            <button [routerLink]="['/basket']">Zurück zum Warenkorb</button>
            <button (click)="restriction = null">
                <i class="fa-solid fa-circle-check"></i>
                Fortfahren
            </button>
        </div>
    </div>
    <div class="background"></div>
</div>
}
}

}
}
<div help-triangle></div>